import { CATEGORIES } from "@gumtree/shared/src/constants/category"

export const shouldFetchVipSellerInfo = (data: any) => {
    try {
        if (data.model?.vipData?.advert?.sellerId !== 0) {
            const attributes = data.model?.vipData?.advert?.attributes;
            let sellerType;
            if (Array.isArray(attributes)) {
                const sellerTypeAttr = attributes.find((attr) => attr.key === 'seller_type');
                sellerType = sellerTypeAttr?.value;
            }
            return matchSellerInfoWithCategory({l1Category: data.model?.l1Category?.id, sellerType});
        }
        return false;
    } catch (error) {
        console.error('shouldFetchVipSellerInfo', error);
        return false;
    }
}

export const matchSellerInfoWithCategory = ({l1Category, sellerType}) => {
    if (l1Category === CATEGORIES.FOR_SALE.id)
        return true;
    else if (l1Category === CATEGORIES.PET.id)
        return true;
    else if (l1Category === CATEGORIES.PROPERTY.id || l1Category === CATEGORIES.MOTORS.id) {
        return sellerType === 'Private';
    }
    return false;
}

export default shouldFetchVipSellerInfo;
